import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PaymentPage from './paymentPage/PaymentPage';
import HomePage from './views/Home';
import NotFound from './views/NotFound';
import PaymentLinkTermsPage from './terms/PaymentLinkTermsPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/payment/:referenceId" element={<PaymentPage />} />
        <Route path="/terms" element={<PaymentLinkTermsPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
